<div [@routeAnimations]="o && o.activatedRouteData
      && o.activatedRouteData['animation']">
      <div class="fadeMe"></div>
<router-outlet #o="outlet" (activate)="onActivate($event)" >
</router-outlet>
<div id="top"></div>

</div>
